import React from 'react';
import { ContentTemplate, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { WithdrawDetails } from '../../api/candidate/exam/model';
import { WithdrawalReviewResponse } from '../../api-refactored/non-national-exam-registration/useGetNonNationalExamWithdrawalReview';

const useStyles = makeStyles()((theme) =>
({
  marginBottom4: {
    marginBottom: theme.spacing(4),
  },
  subheader: {
    marginBottom: theme.spacing(4),
  },
}));

interface ReviewWithdrawalDataTableProps {
  withdrawalDetails: WithdrawDetails | WithdrawalReviewResponse;
}

const ReviewWithdrawalCandidateParticulars = ({
  withdrawalDetails,
}: ReviewWithdrawalDataTableProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ContentTemplate isDividerBottom continuous type="large">
      <Grid className={classes.marginBottom4}>
        <Typography variant="h3" className={classes.marginBottom4}>
          {t('withdrawal->>ReviewWithdrawal.CandidateParticulars')}
        </Typography>
        <Grid container direction="row">
          <Grid md={6} sm={12} xs={12}>
            <KeyValue
              id="idType"
              keyText={t('withdrawal->>ReviewWithdrawal.IDType')}
              valueText={withdrawalDetails.candidateDetails.idType}
            />
          </Grid>
          <Grid md={6} sm={12} xs={12}>
            <KeyValue
              id="idNo"
              keyText={t('withdrawal->>ReviewWithdrawal.IDNo')}
              valueText={withdrawalDetails.candidateDetails.nricFin}
            />
          </Grid>
        </Grid>
        <Grid>
          <KeyValue
            id="candidateName"
            keyText={t('withdrawal->>ReviewWithdrawal.CandidateName')}
            valueText={withdrawalDetails.candidateDetails.statutoryName}
          />
        </Grid>
        <Grid container direction="row">
          <Grid md={6} sm={12} xs={12}>
            <KeyValue
              id="nationality"
              keyText={t('withdrawal->>ReviewWithdrawal.Nationality')}
              valueText={withdrawalDetails.candidateDetails.nationality}
            />
          </Grid>
          <Grid md={6} sm={12} xs={12}>
            <KeyValue
              id="citizenship"
              keyText={t('withdrawal->>ReviewWithdrawal.Citizenship')}
              valueText={withdrawalDetails.candidateDetails.citizenship}
            />
          </Grid>
        </Grid>
        <Grid>
          <KeyValue
            id="schoolName"
            keyText={t('withdrawal->>ReviewWithdrawal.SchoolName')}
            valueText={withdrawalDetails.candidateDetails.schoolName}
          />
        </Grid>
      </Grid>
    </ContentTemplate>
  );
};

export default ReviewWithdrawalCandidateParticulars;
